module.exports = __webpack_public_path__ + "img/motorcycle-enclose.f9ce7872.jpg";